import React from "react";
import {DashboardTemplateConfig} from "../../../../../../core/gd-modules/dashboard/templates/templates-custom";
import Template from "../../../../../../core/model2/template/template";

type Props = {
    imgClassName?   : string;
    template        : DashboardTemplateConfig | Template,
    onClick         : callback,
}

export default function DashboardTemplatePreview(props:Props) {

    const bgClasses = Classes("m-l-20 ui5-bg-gray ui5-border-all overflow-hidden flex-no-shrink flex-row-center-center")
    const bgStyle : React.CSSProperties = {
        width           : "160px",
        height          : "90px",
        borderRadius    : "8px",
        position        : "relative"
    }

    const preview  = props.template.preview
    const backgroundImage = `url('/app/web/skin/common/modules/dashboard/dashboard-preview/${gd.skin.layoutTheme}/${preview}')`

    const imgStyle         = {
        backgroundImage     : backgroundImage,
        backgroundRepeat    : "no-repeat",
    }

    const onClick = () => {
        props.onClick(props.template)
    }

    return (

        <div className="flex-row-left-center w-100p m-t-15" onClick={onClick}>

            <div className={bgClasses} style={bgStyle}>
                <div className={props.imgClassName} style={imgStyle}/>
            </div>

            <div className="flex-column-left-top m-l-20 flex-1">
                <div className="ui5-title-smaller-dark m-t-5">
                    {props.template.name}
                </div>
                <div className="ui5-txt-not-important-small m-t-10 lh-14em">
                    {props.template.description}
                </div>
            </div>
        </div>
    )

}
